exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dropzone{font-family:Arial,sans-serif;letter-spacing:.2px;width:100%;background:hsla(220,8%,92%,.75)}.dropzone.dz-started .dz-message{display:block!important}.dropzone-custom-title{margin-top:0;color:#009e4f}.subtitle{color:#314b5f}#dropzone>div.dz-preview.dz-file-preview,#dropzone>div.dz-preview.dz-file-preview.dz-processing.dz-success{height:30px!important}#dropzone>div.dz-preview.dz-file-preview>div.dz-details{background-color:#009e4f!important}#dropzone>div.dz-preview.dz-file-preview.dz-processing.dz-error.dz-complete>div.dz-details{background-color:#ff5b57!important}#dropzone.auto>div.dz-preview.dz-file-preview>a{top:10px;right:10px;bottom:none;border:none;text-decoration:none;font-size:14px!important;height:25px;padding:0}#dropzone.auto .dz-preview{display:none!important}.dz-remove{right:10px!important;padding:5px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e447f0a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/AddAttachment.vue
// module id = 1392
// module chunks = 0